module.exports = __webpack_public_path__ + "img/patrimoine.6b445cb6.jpg";